<style></style>

<template>
    <div>
        Do you really want to delete?
        <br><br>
        <button class="btn btn-blue-blue float-right" @click="confirm">Confirm Delete</button>
    </div>
</template>

<script>

    export default {
        methods: {
            confirm() {
                this.$emit('confirmDelete')
            }
        }
    }
</script>